const Error404 = () => {
	return (
		<div>
			<h1>Estamos en Error404...</h1>
		</div>
	);
};

export default Error404;
